import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import OrganizationAutoComplate from '@/components/AutoCompletes/OrganizationAutoComplate.vue'
import DepartmentSelectBox from '@/components/UserRoles/DepartmentSelectBox.vue'
import {
  userRoleSearchFormType,
  officeType,
  departmentType
} from '@/types/requests/userRoleSearchForm'
import { Ref, ref, computed, onMounted, watch } from 'vue'
import SelectRoleChecker from '@/router/selectRoleChecker'
import {
  MANAGEMENT_OFFICE,
  SUB_MANAGEMENT_OFFICE,
  INSTALLATION_OFFICE,
  OPERATION_OFFICE,
  DEPARTMENT
} from "@/services/consts/user_role";
import i18n from '@/lang/i18n';
import { 
  saveDataToSessionStorage, 
  loadDataFromSessionStorage, 
  clearSessionStorage 
} from "@/services/functions/sessionStorage";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFormContent',
  props: {
    modelValue: {},
    errors: {}
  },
  emits: [
  'update:modelValue'
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const showableOfficeableTypes: Ref<officeType[]> = ref([])
const selectedOfficeableType: Ref<officeType> = ref({id:null, name:"", type:"", departments: []})
const isDepartment = ref(false)
const organization_id = ref()
const organization_type = ref("" as string)

const emits = __emit
const props = __props

__expose({
  resetOfficeableType,
  saveFormValuesToSessionStorage,
  clearSessionStorage
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

onMounted(() => {
  const current_role = SelectRoleChecker.getCurrentRole()
  if (current_role?.organization_id) {
    organization_id.value = current_role.organization_id
  }
  if (current_role?.organization_id) {
    organization_type.value = current_role.organization_type
  }
  if (organization_type.value == DEPARTMENT.type) {
    isDepartment.value = true
  }
  setShowableOfficeType()
  const savedFormValues = loadDataFromSessionStorage('userRolesSearchFormContent');
    if (savedFormValues) {
      selectedOfficeableType.value = savedFormValues.officeable_type;
      modelValue.value.organization = savedFormValues.organization;
      modelValue.value.department = savedFormValues.department;
      modelValue.value.display_name = savedFormValues.display_name;
    }
  watch(() => modelValue.value.organization, (newValue) => {
    const isIncluded = newValue?.departments.some(department => department.id === modelValue.value?.department?.id)
    if (!isIncluded) {
      modelValue.value.department = []
    }
  })
})

function setShowableOfficeType(){
  const org_type = organization_type.value.split('\\')[2];
  const managementOffice = convertOfficeableType(MANAGEMENT_OFFICE)
  const subManagementOffice = convertOfficeableType(SUB_MANAGEMENT_OFFICE)
  const installationOffice = convertOfficeableType(INSTALLATION_OFFICE)
  const operationOffice = convertOfficeableType(OPERATION_OFFICE)
  const department = convertOfficeableType(DEPARTMENT)

  switch (org_type) {
    case managementOffice.type:
      showableOfficeableTypes.value = [
        managementOffice,
        subManagementOffice,
        installationOffice,
        operationOffice
      ]
      break;
    case subManagementOffice.type:
      showableOfficeableTypes.value = [
        subManagementOffice,
        installationOffice,
        operationOffice
      ]
      break;
    case installationOffice.type:
      showableOfficeableTypes.value = [
        installationOffice,
        operationOffice
      ]
      break;
    case operationOffice.type:
      showableOfficeableTypes.value = [
        operationOffice
      ]
      break;
    case department.type:
      showableOfficeableTypes.value = [
        operationOffice
      ]
      break;
    default:
      showableOfficeableTypes.value = [];
  }
}

function convertOfficeableType(office: {id: number, name: string, type: string}){
  let formated = JSON.parse(JSON.stringify(office))
  formated.type = office.type.split('\\')[2];
  return formated
}

function resetOfficeableType(){
  selectedOfficeableType.value = { id: null, name: "", type: "" }
}

function saveFormValuesToSessionStorage() {
  saveDataToSessionStorage('userRolesSearchFormContent', {
    officeable_type: selectedOfficeableType.value,
    organization: modelValue.value.organization,
    department: modelValue.value.department,
    display_name: modelValue.value.display_name,
  });
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_select, _mergeProps({
      class: "mb-2",
      modelValue: selectedOfficeableType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOfficeableType).value = $event)),
      items: showableOfficeableTypes.value,
      "item-title": "name",
      "item-value": "id"
    }, {'return-object': true}, {
      label: _unref(i18n).global.t('pages.userRoles.search.officeType'),
      clearable: false
    }), null, 16, ["modelValue", "items", "label"]),
    _createVNode(OrganizationAutoComplate, {
      class: "mb-2",
      modelValue: modelValue.value.organization,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.organization) = $event)),
      selectedOfficeableType: selectedOfficeableType.value,
      errorMessages: __props.errors?.organization
    }, null, 8, ["modelValue", "selectedOfficeableType", "errorMessages"]),
    _createVNode(DepartmentSelectBox, {
      modelValue: modelValue.value.department,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.department) = $event)),
      organization: modelValue.value.organization,
      "error-messages": __props.errors?.department,
      isEdit: false,
      isDepartment: isDepartment.value,
      clearable: true
    }, null, 8, ["modelValue", "organization", "error-messages", "isDepartment"]),
    _createVNode(_component_v_text_field, {
      label: _unref(i18n).global.t('pages.userRoles.search.role'),
      modelValue: modelValue.value.display_name,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.display_name) = $event)),
      "error-messages": __props.errors?.display_name
    }, null, 8, ["label", "modelValue", "error-messages"])
  ], 64))
}
}

})